module.exports = __webpack_public_path__ + "media/images/pubmatic_small_logo-207f1e7865031687c598eeaf27650173.png";